import React from 'react';
import { useViewport } from '../../contexts/ViewportContext';
import { useStatusBarInfo } from '../../hooks/useStatusBarInfo';

export function TopicSkeleton() {
  const { isMobile } = useViewport();
  const { isNativeApp, statusBarHeight } = useStatusBarInfo();

  // Add a header placeholder for mobile with status bar padding
  const headerSkeleton = isMobile && (
    <div
      className="sticky top-0 z-50 bg-[var(--content-bg-color)] "
      style={{
        paddingTop: isNativeApp ? `${statusBarHeight}px` : '0',
      }}
    >
      <div className="flex items-center justify-between h-14 px-4">
        <div className="w-8 h-8 rounded-lg bg-gray-100" />
        <div className="w-24 h-6 bg-gray-100 rounded" />
        <div className="w-8 h-8 rounded-lg bg-gray-100" />
      </div>
      <div className="px-4 py-3">
        <div className="h-10 w-full bg-gray-100 rounded-lg" />
      </div>
    </div>
  );

  return (
    <div className="animate-pulse h-full">
      {headerSkeleton}

      {/* Create an array of 3 skeleton items */}
      {[...Array(5)].map((_, index) => (
        <div key={index} className="py-3 px-4">
          <div className="flex items-center gap-3">
            {/* Topic icon skeleton - match the size and shape in TopicItem */}
            <div className="w-8 h-8 rounded-lg bg-gray-100 flex-shrink-0" />

            {/* Topic title and description skeleton - match the layout in TopicItem */}
            <div className="flex-1 min-w-0 space-y-2">
              <div className="h-5 w-3/4 bg-gray-100 rounded" />
              <div className="h-4 w-1/2 bg-gray-100 rounded" />
            </div>

            {/* Empty space for the menu button */}
            <div className="w-6" />
          </div>
        </div>
      ))}
    </div>
  );
}
